// theme-sources/js/core/config.js

export const CONFIG = {
  DEBUG: window.__ZIGGY_DEBUG__ === true,
  THEME_NAME: "ziggy",
};

export const SECTIONS = {
  CART_DRAWER: "drawer-right",
  CART_LOADER: "ziggy-drawer[name='cart'] .loading-overlay",
};

export const CART_CONFIG = {
  ON_CHANGE_DEBOUNCE_TIMER: 500,
  FAKE_VARIANT_ID: 55622259212662,
};

export const SECTION_REFRESH_RESOURCE_TYPE = {
  product: "product",
};
